import Header from "./Header";
import Footer from "./Footer";
import Sidebar from "./Sidebar";
import Notifications from "./Notifications";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";

const Layout = props => {
	const meta = useSelector(state => state.meta);

	const [settings, setSettings] = useState([]);

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		axios
			.get(`${process.env.REACT_APP_API_URL}/settings/siteInfo`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setSettings(response.data.data.siteInfo);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	return (
		<div className="main-wrapper">
			<Sidebar settings={settings} />
			<div className="content-wrapper" id="content-wrapper">
				<Header breadcrumbTitle={meta.breadcrumb} settings={settings} />
				<Notifications />
				<div className="inner-wrapper">
					<div className="content">
						<div className="page-meta">
							<h1 className="main-title">{meta.title}</h1>
							{meta.button.show && (
								<Link to={meta.button.link} className="bt bt-success">
									{meta.button.text}
								</Link>
							)}
						</div>
						{props.children}
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
};

export default Layout;
